import util from '../util'

let controller = 'Favorecidos'

export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllFavorecidosByConta: function (codigoConta) {
    return util.Axios.Get(controller + '/GetAllFavorecidosByConta', codigoConta)
  },
  PostContaFavorecido: function (dto) {
    return util.Axios.Post(controller + '/PostContaFavorecido', dto)
  },
  PutContaFavorecido: function (dto) {
    return util.Axios.Put(controller + '/PutContaFavorecido', '', dto)
  }
})
